var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.543.727l.2-.2c.702-.702 1.904-.702 2.606 0 .701.7.701 1.903 0 2.605l-.2.2c.8.902.8 2.305-.101 3.106L7.315 22.271c-.1.1-.2.2-.4.2L.901 23.976c-.401.1-.802-.1-.902-.601v-.401l1.503-6.113c0-.1.1-.3.2-.4L16.435 1.728a.77.77 0 00-1.002.1l-5.01 5.01c-.3.3-.802.3-1.103 0-.3-.3-.3-.801 0-1.102l5.01-5.01a2.438 2.438 0 013.207 0c.902-.802 2.205-.802 3.007 0zm-.902 1.102c-.3-.3-.802-.3-1.102 0L2.906 17.46l-1.202 4.71 4.71-1.202L22.045 5.336c.3-.3.3-.802 0-1.102L19.64 1.829z",
    fill: "#fff"
  })));
}
export default SvgPen;